import { types } from 'actions/dataEnrichment';

const defaultState = {
  filters: {
    pageSize: 50,
    pageNumber: 0,
    orderBy: 'createdAt',
    order: 'desc',
    searchFilter: '',
    status: [],
    type: [],
  },
  dateOption: null,
  signalRDataEnrichmentId: null,
};

const REDUCER = {
  [types.SET_DATA_ENRICHMENT_FILTERS]: (state, action) => ({
    ...state,
    [action.payload.userId]: {
      ...(state[action.payload.userId] || {}),
      filters: { ...defaultState.filters, ...action.payload.value },
    },
  }),
  [types.RESTORE_STATE]: (state, action) => {
    if (!action.payload) {
      return {
        ...state,
        restoringState: false,
      };
    }

    let restoredState = JSON.parse(JSON.stringify(action.payload));
    restoredState = {
      ...restoredState,
      ...defaultState,
    };
    restoredState.restoringState = false;

    return restoredState;
  },
  [types.SET_DATA_ENRICHMENT_DATE_OPTION]: (state, action) => ({
    ...state,
    [action.payload.userId]: {
      ...(state[action.payload.userId] || {}),
      dateOption: action.payload.option,
    },
  }),
  [types.SIGNAL_R_ENRICHMENT_UPDATE]: (state, action) => ({
    ...state,
    signalRDataEnrichmentId: action.payload,
  }),
};

const reducer = (state = defaultState, action) => {
  const handler = REDUCER[action.type];
  return handler ? handler(state, action) : state;
};

export default reducer;
